import script from "./SkuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkuItem.vue?vue&type=script&lang=ts&setup=true"

import "./SkuItem.vue?vue&type=style&index=0&id=79624813&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79624813"]])

export default __exports__